<template>
  <div class="Supply_demand_container">
    <div class="Supply_demand_content">
      <router-view />
    </div>
    <bottom-url />
  </div>
</template>

<script>
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';

export default {
  name: 'index',
  components: { BottomUrl },
};
</script>

<style scoped>
.Supply_demand_container {
  width: 100%;
  height: calc(100vh - 85px);
}
.Supply_demand_content {
  width: 100%;
  min-height: calc(100% - 250px);
}
</style>
